import Request from "@/common/net/request.js";
const request = new Request();
// 获取列表
export function getPage(data) {
  return request.send({
    url: `/pmy/freight/order/freight/manage/page`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}

// 取消订单
export function cancelOrder(data) {
  return request.send({
    url: `/pmy/freight/order/freight/cancel`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}

export function setReal(data) {
  return request.send({
    url: `/joker/order/real`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}
// 根据步骤ID获取订单取消详情
export function getCancelDetail(stepId) {
  return request.send({
    url: `/pmy/freight/order/freight/cancel/detail?stepId=${stepId}`,
    method: "get",
  });
}

// 根据步骤ID获取订单派单详情
export function getDispatchDetail(stepId) {
  return request.send({
    url: `/pmy/freight/order/freight/dispatch/detail?stepId=${stepId}`,
    method: "get",
  });
}

// 根据步骤ID获取订单装卸货详情
export function getPointDetail(stepId) {
  return request.send({
    url: `/pmy/freight/order/freight/point/detail?stepId=${stepId}`,
    method: "get",
  });
}
// 根据步骤ID获取订单回单详情
export function getReceiveDetail(stepId) {
  return request.send({
    url: `/pmy/freight/order/freight/receipt/info?stepId=${stepId}`,
    method: "get",
  });
}

// 根据步骤ID获取订单改派详情
export function getReassignDetail(stepId) {
  return request.send({
    url: `/pmy/freight/order/freight/reassign/detail?stepId=${stepId}`,
    method: "get",
  });
}

// 根据步骤ID获取订单退款详情
export function getTuiDetail(stepId) {
  return request.send({
    url: `/pmy/freight/order/freight/refund/info?stepId=${stepId}`,
    method: "get",
  });
}

// 根据步骤ID获取货主支付详情
export function getPayDetail(stepId) {
  return request.send({
    url: `/pmy/freight/order/freight/payment/info?stepId=${stepId}`,
    method: "get",
  });
}

// 订单管理--统计信息
export function getOverview(data) {
  return request.send({
    url: `/pmy/freight/order/freight/manage/overview`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}
// 导出
export function downloadTable(data) {
  return request.send({
    url: `/pmy/freight/order/freight/manage/export`,
    method: "post",
    data,
    config: {
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}
